<template>
  <div id="Content">
    <!-- <el-container>
      <el-header class="pageTitle">百科全书资源库</el-header>
    </el-container> -->
    <div class="publishPreviewNav">
      <img src="../../../../img/previewLogo.png" alt="" />
      <span class="publishNavTitle">大百科</span>
    </div>
    <!-- 页面标题 -->
    <div class="contentBox">
      <div class="previewPageTitle">
        <img src="../../../../img/previewLogo.png" alt="" />
        <span
          style="
            color: #50b58d;
            float: left;
            margin-left: 10px;
            letter-spacing: 0.2em;
            font-size: 30px;
            font-weight: bolder;
          "
          >百科资源库</span
        >

        <span style="float: right; cursor: pointer" @click="printPage()"
          ><i class="el-icon-printer"></i>&nbsp;&nbsp;打印</span
        >
      </div>
      <!-- 条目名称 -->
      <div class="articleTitle">
        <p v-html="articleTitle"></p>
      </div>
      <!-- 基本信息 -->
      <div class="basicInfo">
        <div class="moduleTitle">基本信息</div>
        <div class="basicContent">
          <div class="authorText">
            <p>
              <span>作者：</span>
              <span class="author" style="font-weight: normal">{{authorText}}</span>
            </p>
          </div>
          <div class="authorText">
            <p><span>来源：</span>{{ sourceInfo }}</p>
          </div>
          <div class="authorText" style="width: 100%">
            <p><span>分支：</span>{{ subjectInfo }}</p>
          </div>
          <div class="authorText">
            <p v-if="securityLevel == 10"><span>安全级别：</span>低</p>
            <p v-if="securityLevel == 20"><span>安全级别：</span>中</p>
            <p v-if="securityLevel == 30"><span>安全级别：</span>高</p>
            <p v-if="securityLevel == 40"><span>安全级别：</span>最高</p>
          </div>
        </div>
      </div>
      <!-- 标签信息 -->
      <div class="basicInfo" v-if="adverTagsData.length>0 || itemTagsData.length>0">
        <div class="moduleTitle">标签信息</div>
        <div class="basicContent">
          <div class="authorText"  v-if="adverTagsData.length>0">
            <p>
              <span>广告标签：</span>
              <el-tag style="margin-right: 10px;" v-for="(item,index) in adverTagsData" :key="index">{{item}}</el-tag>
            </p>
          </div>
          <div class="authorText"  v-if="itemTagsData.length>0">
            <p>
              <span>条目标签：</span>
              <el-tag type="success" style="margin-right: 10px;" v-for="(item,index) in itemTagsData" :key="index">{{item.tagName}}</el-tag>
            </p>
          </div>
          <!-- <div class="authorText" v-if="contentTagsData.length>0">
            <p>
              <span>内容标签：</span>
              <el-tag type="warning" style="margin-right: 10px;" v-for="(item,index) in contentTagsData" :key="index">{{item.tagName}}</el-tag>
            </p>
          </div> -->
        </div>
      </div>
      
      <!-- 义项信息 -->
      <div class="anotherWords">
        <div class="moduleTitle">义项信息</div>
        <ul class="anotherWordsList"></ul>
      </div>
      <!-- 条头 -->
      <div class="headText">
        <div class="moduleTitle">条头</div>
        <div class="infoText">
          <p v-for="(item, index) in headTextList" :key="index">
            <span>{{ item.name }}:</span>
            <span v-html="item.value" style="font-weight: normal;"></span>
          </p>
        </div>
      </div>
      <!-- 摘要 -->
      <div class="summaryFields">
        <div class="moduleTitle">摘要</div>
        <div class="infoText">
          <p v-for="(item, index) in summaryFieldsList" :key="index">
            <span>{{ item.name }}:</span>
            {{ item.value }}
          </p>
        </div>
      </div>
      <!-- 定性语 -->
      <div class="descText">
        <div class="moduleTitle">定性语</div>
        <div class="descTextContent"></div>
      </div>
      <!-- 正文 -->
      <div class="mainContent">
        <div class="moduleTitle">正文</div>
        <div class="previewContent"></div>
      </div>
      <!-- 著作 -->
      <div class="opusContent">
        <div class="moduleTitle">著作</div>
        <ul class="opusList"></ul>
      </div>
      <!-- 引文 -->
      <div class="refContent">
        <div class="moduleTitle">引文</div>
        <ul class="refList"></ul>
      </div>
      <!-- 大事年表 -->
      <div class="chronologyContent fontsize">
        <div class="moduleTitle">大事年表</div>
        <ul class="chronologyList" v-if="chronologyList.length>0">
          <li v-for="item in chronologyList" :key="item.sorder">
            <div class="chronologyItemTitle">
              {{ item.sbeginTime }}
            </div>
            <div v-html="item.sText"  class="chronologyItemContent"></div>
          </li>
        </ul>
      </div>
      <!-- 扩展阅读 -->
      <div class="extendContent">
        <div class="moduleTitle">扩展阅读</div>
        <ul class="extendList"></ul>
      </div>
      <!-- 扩展内容 -->
      <div class="otherExtendContent">
        <div class="moduleTitle">扩展内容</div>
        <ul class="otherExtendList"></ul>
      </div>
    </div>

    <!-- 页面目录 -->
    <div class="menuBox rt-panel">
      <div style="height: 100%; overflow: scroll">
        <div class="nav-title"><i class="el-icon-menu"></i>目录</div>
        <ul class="catalogue-box">
          <li
            v-for="(item, index) in catalogue"
            :key="index"
            :class="'catalogue' + item.level"
            :id="'menu' + item.id"
          >
            <a @click="menuClick(item)"
              ><span>{{ item.title }}</span>
            </a>
          </li>
        </ul>
        <el-button
          class="menuButton"
          icon="el-icon-close"
          @click="closeSide()"
        ></el-button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      data: [],
      articleTitle: "",
      authorText: "",
      sourceInfo: "",
      subjectInfo: "",
      descText: "",
      securityLevel: 10,
      headTextList: [],
      chronologyList: [],
      summaryFieldsList: [],
      refText: [],
      catalogue: [],
      scrollDistance: 0,
      opusData: [],
      adverTagsData:[],
      itemTagsData:[],
      contentTagsData:[],
      param:{},
    };
  },
  props: {
    topIndex: String,
  },
  mounted() {
    window.addEventListener("scroll", this.updateScrollDistance);

    let that = this;
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    // var param = {};
    if (this.$route.query.version) {
      this.param.version = this.$route.query.version;
      this.param.id = this.$route.query.id;
      this.getContentData(this.$route.query.id,true)
    }else if(this.$route.query.id){
      this.param.id = this.$route.query.id;
      this.getContentData(this.$route.query.id,false)
    }else if(this.$route.query.name){
        var param = {
          name: this.$route.query.name,
          sourceId: this.$route.query.sourceId
        };
       $.ajax({
          type: "GET",
          dataType: "json",
          data: param,
          url: "/zyk/word/getWordByName",
          success: function (response) {
            if (response.code == 200) {
              if(response.obj.filter((item) => {return item.status == 20}).length>0){
                // that.param.id = response.obj.filter((item) => {return item.status == 20})[0].id
                that.getContentData(response.obj.filter((item) => {return item.status == 20})[0].id,false)
              }else{
                // that.param.id = response.obj[0].id
                that.getContentData(response.obj[0].id,false)
              }
            } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
            }
          },
          error: function (data) {
            console.log(data);
          },
        });
    }
    setTimeout(function () {
      // $.ajax({
      //   type: "GET",
      //   dataType: "json",
      //   url: "/zyk/word/preview",
      //   data: that.param,
      //   contentType: "application/json;charset=utf-8",
      //   success: function (response) {
      //     if (response.code == 200) {
      //       var data = response.obj;
            
      //       document.title = data.name + "-大百科";
      //       if(data.adverTags){
      //         that.adverTagsData = data.adverTags;
      //       }

      //       if(data.wordTags.length>0){
      //         data.wordTags.forEach((item)=>{
      //           switch (item.type) {
      //             case 10:
      //               that.itemTagsData.push(item)
      //               break;
      //             case 20:
      //               that.contentTagsData.push(item)
      //               break;
      //             default:
      //               break;
      //           }
      //         })
      //       }

      //       if (data.headText != "[]") {
      //         that.headTextList = JSON.parse(data.headText);
      //       }
      //       if (data.authorText != "[]" && data.authorText != "[{}]") {
      //         // that.authorText = JSON.parse(data.authorText)[0].authorName;
      //         var athorHtml = "";
      //           JSON.parse(data.authorText).forEach(function (item) {
      //             if (item.isAway == "Y") {
      //               athorHtml +=
      //                 "、<span style='font-weight:normal;border: 1px solid #ccc'>" +
      //                 item.authorName +
      //                 "</span>";
      //             } else {
      //               athorHtml +=
      //                 "、<span style='font-weight:normal'>" +
      //                 item.authorName +
      //                 "</span>";
      //             }
      //           });
      //           athorHtml = athorHtml.slice(1);
      //           $(".author").html(athorHtml);
      //       }
      //       // 处理大事年表
      //       if (data.chronologyText != "{}" && data.chronologyText != null && data.chronologyText != "[]") {
      //         that.chronologyList = JSON.parse(data.chronologyText).list;
      //       } else {
      //         $(".chronologyContent").hide();
      //       }
      //       if (data.summaryFields != "[]" && data.summaryFields != null) {
      //         that.summaryFieldsList = JSON.parse(data.summaryFields);
      //       }

      //       if (data.descText != "") {
      //         that.descText = data.descText;
      //         $(".descTextContent").html(data.descText);
      //       }

      //       that.articleTitle = data.name;
      //       that.sourceInfo = data.sourceInfo.name;
      //       that.subjectInfo = data.subjectInfo.subBranch;
      //       that.securityLevel = data.securityLevel;
      //       // that.refText = data.refText;

      //       // 处理著作
      //       if (data.opusText != "[]") {
      //         var opusData = JSON.parse(data.opusText);
      //         that.opusData = JSON.parse(data.opusText);
      //         var opusHtml = "";
      //         for (var i = 0; i < opusData.length; i++) {
      //           opusHtml += "<li>";
      //           if (opusData[i].mainPerson != undefined) {
      //             opusHtml += opusData[i].mainPerson + " . ";
      //           }
      //           if (opusData[i].bookName != undefined) {
      //             opusHtml += opusData[i].bookName + " . ";
      //           }
      //           if (opusData[i].publishAddress != undefined) {
      //             opusHtml += opusData[i].publishAddress + " : ";
      //           }
      //           if (opusData[i].publishauthor != undefined) {
      //             opusHtml += opusData[i].publishauthor + " . ";
      //           }
      //           if (opusData[i].publishYear != undefined) {
      //             opusHtml += opusData[i].publishYear + " . ";
      //           }
      //           opusHtml += "</li>";
      //         }
      //         $(".opusContent .opusList").html(opusHtml);
      //       } else {
      //         $(".opusContent").hide();
      //       }

      //       // 处理引文
      //       if (data.refText != "[]") {
      //         var refData = JSON.parse(data.refText);
      //         var refHtml = "";
      //         for (var j = 0; j < refData.length; j++) {
      //           if (refData[j].type == "1") {
      //             var ref1Data = refData[j].list;
      //             for (var k = 0; k < ref1Data.length; k++) {
      //               refHtml += "<li>";
      //               if (ref1Data[k].mainPerson != undefined) {
      //                 refHtml += ref1Data[k].mainPerson + " . ";
      //               }
      //               if (ref1Data[k].bookName != undefined) {
      //                 refHtml += ref1Data[k].bookName + " . ";
      //               }
      //               if (ref1Data[k].publishAddress != undefined) {
      //                 refHtml += ref1Data[k].publishAddress + " : ";
      //               }
      //               if (ref1Data[k].publishauthor != undefined) {
      //                 refHtml += ref1Data[k].publishauthor + " . ";
      //               }
      //               if (ref1Data[k].publishYear != undefined) {
      //                 refHtml += ref1Data[k].publishYear + " . ";
      //               }
      //               refHtml += "</li>";
      //             }
      //           } else if (refData[j].type == "2") {
      //             var ref2Data = refData[j].list;
      //             for (var l = 0; l < ref2Data.length; l++) {
      //               refHtml += "<li>";
      //               if (ref2Data[l].linkAddress != undefined) {
      //                 refHtml +=
      //                   "<a href='" +
      //                   ref2Data[l].linkAddress +
      //                   " target='_blank'>";
      //               }
      //               if (ref2Data[l].mainPerson != undefined) {
      //                 refHtml += ref2Data[l].mainPerson + " . ";
      //               }
      //               if (ref2Data[l].bookName != undefined) {
      //                 refHtml += ref2Data[l].bookName + " . ";
      //               }
      //               if (ref2Data[l].linkAddress != undefined) {
      //                 refHtml += "</a>";
      //               }
      //               if (ref2Data[l].bookNameL != undefined) {
      //                 refHtml += ref2Data[l].bookNameL + " , ";
      //               }
      //               if (ref2Data[l].publishYear != undefined) {
      //                 refHtml += ref2Data[l].publishYear + " . ";
      //               }
      //               if (ref2Data[l].Volume != undefined) {
      //                 refHtml += ref2Data[l].Volume + " . ";
      //               }
      //               if (ref2Data[l].pageNumber != undefined) {
      //                 refHtml += ref2Data[l].pageNumber + " . ";
      //               }
      //               refHtml += "</li>";
      //             }
      //           }
      //         }

      //         $(".refContent .refList").html(refHtml);
      //       } else {
      //         $(".refContent").hide();
      //       }

      //       // 处理otherText内容
      //       if (data.otherText != "[]" && data.otherText != null) {
      //         var otherData = JSON.parse(data.otherText),
      //           otherHtml = "";
      //         otherData.forEach((item) => {
      //           otherHtml += "<li>" + item + "</li>";
      //         });
      //         $(".otherExtendContent .otherExtendList").html(otherHtml);
      //       } else {
      //         $(".otherExtendContent").hide();
      //       }

      //       // 处理义项信息
            
      //       if (data.anotherWords.length > 1) {
      //         var anotherWordsData = data.anotherWords,
      //         anotherWordsHtml = "";
      //         var listShow = ''
      //         anotherWordsData.forEach((item) => {
      //           if(item.anoterName && item.anoterName!=""){
      //             listShow = item.anoterName
      //           }else{
      //             listShow = item.subBranch
      //           }
      //           if(item.id == data.id){
      //             anotherWordsHtml += "<li>" + listShow + "</li>";  
      //           }else{
      //             anotherWordsHtml += "<li><a href='/preview?id="+ item.id +"' target='_blank'>" + listShow + "</a></li>";  
      //           }
      //         });
      //         $(".anotherWords .anotherWordsList").html(anotherWordsHtml);
              
      //       } else {
      //         $(".anotherWords").hide();
      //       }

      //       // 处理扩展阅读
      //       if (data.extendText != "[]") {
      //         var extendData = JSON.parse(data.extendText);
      //         var extendHtml = "";
      //         for (var m = 0; m < extendData.length; m++) {
      //           if (extendData[m].type == "1") {
      //             var extend1Data = extendData[m].list;
      //             for (var p = 0; p < extend1Data.length; p++) {
      //               extendHtml += "<li>";
      //               if (extend1Data[p].linkAddress != undefined) {
      //                 extendHtml +=
      //                   "<a href='" +
      //                   extend1Data[p].linkAddress +
      //                   " target='_blank'>";
      //               }
      //               if (extend1Data[p].leaders != undefined) {
      //                 extendHtml += extend1Data[p].leaders + " . ";
      //               }
      //               if (extend1Data[p].speechName != undefined) {
      //                 extendHtml += extend1Data[p].speechName + " . ";
      //               }
      //               if (extend1Data[p].linkAddress != undefined) {
      //                 extendHtml += "</a>";
      //               }
      //               extendHtml += "</li>";
      //             }
      //           } else if (extendData[m].type == "2") {
      //             var extend2Data = extendData[m].list;
      //             for (var q = 0; q < extend2Data.length; q++) {
      //               extendHtml += "<li>";
      //               if (extend2Data[q].mainPerson != undefined) {
      //                 extendHtml += extend2Data[q].mainPerson + " . ";
      //               }
      //               if (extend2Data[q].bookName != undefined) {
      //                 extendHtml += extend2Data[q].bookName + " . ";
      //               }
      //               if (extend2Data[q].publishAddress != undefined) {
      //                 extendHtml += extend2Data[q].publishAddress + " : ";
      //               }
      //               if (extend2Data[q].publishauthor != undefined) {
      //                 extendHtml += extend2Data[q].publishauthor + " . ";
      //               }
      //               if (extend2Data[q].publishYear != undefined) {
      //                 extendHtml += extend2Data[q].publishYear + " . ";
      //               }
      //               extendHtml += "</li>";
      //             }
      //           } else if (extendData[m].type == "3") {
      //             var extend3Data = extendData[m].list;
      //             for (var r = 0; r < extend3Data.length; r++) {
      //               refHtml += "<li>";
      //               if (extend3Data[r].linkAddress != undefined) {
      //                 extendHtml +=
      //                   "<a href='" +
      //                   extend3Data[r].linkAddress +
      //                   " target='_blank'>";
      //               }
      //               if (extend3Data[r].mainPerson != undefined) {
      //                 extendHtml += extend3Data[r].mainPerson + " . ";
      //               }
      //               if (extend3Data[r].bookName != undefined) {
      //                 extendHtml += extend3Data[r].bookName + " . ";
      //               }
      //               if (extend3Data[r].linkAddress != undefined) {
      //                 extendHtml += "</a>";
      //               }
      //               if (extend3Data[r].bookNameL != undefined) {
      //                 extendHtml += extend3Data[r].bookNameL + " , ";
      //               }
      //               if (extend3Data[r].publishYear != undefined) {
      //                 extendHtml += extend3Data[r].publishYear + " . ";
      //               }
      //               if (extend3Data[r].Volume != undefined) {
      //                 extendHtml += extend3Data[r].Volume + " . ";
      //               }
      //               if (extend3Data[r].pageNumber != undefined) {
      //                 extendHtml += extend3Data[r].pageNumber + " . ";
      //               }
      //               extendHtml += "</li>";
      //             }
      //           } else if (extendData[m].type == "4") {
      //             var extend4Data = extendData[m].list;
      //             for (var n = 0; n < extend4Data.length; n++) {
      //               extendHtml += "<li>";
      //               if (extend4Data[n].linkAddress != undefined) {
      //                 extendHtml +=
      //                   "<a href='" +
      //                   extend4Data[n].linkAddress +
      //                   " target='_blank'>";
      //               }
      //               if (extend4Data[n].bookName != undefined) {
      //                 extendHtml += extend4Data[n].bookName + " . ";
      //               }
      //               if (extend4Data[n].websiteName != undefined) {
      //                 extendHtml += extend4Data[n].websiteName + " . ";
      //               }
      //               if (extend4Data[n].linkAddress != undefined) {
      //                 extendHtml += "</a>";
      //               }
      //               extendHtml += "</li>";
      //             }
      //           } else if (extendData[m].type == "5") {
      //             var extend5Data = extendData[m].list;
      //             for (var t = 0; t < extend5Data.length; t++) {
      //               extendHtml += "<li>";
      //               if (extend5Data[t].linkAddress != undefined) {
      //                 extendHtml +=
      //                   "<a href='" +
      //                   extend5Data[t].linkAddress +
      //                   " target='_blank'>";
      //               }
      //               if (extend5Data[t].name != undefined) {
      //                 extendHtml += extend5Data[t].name;
      //               }
      //               if (extend5Data[t].linkAddress != undefined) {
      //                 extendHtml += "</a>";
      //               }
      //               extendHtml += "</li>";
      //             }
      //           }
      //         }
      //         $(".extendContent .extendList").html(extendHtml);
      //       } else {
      //         $(".extendContent").hide();
      //       }

      //       // 生成正文内容
      //       $(".previewContent").html(data.content);
            
      //       $(".previewContent p").each(function() {
      //         $(this).html($(this).html().trimStart())
      //       });

      //       $("note").each(function () {
      //         var sup = $(this).attr("title");
      //         if (sup && sup.length > 0) {
      //           $(this).addClass("websup");
      //           $(this).webuiPopover({
      //             placement: "bottom",
      //             trigger: "hover",
      //             title: "注释内容",
      //             content: sup,
      //             width: 200,
      //           });
      //         }
      //       });

      //       //生成目录

      //       var getMenuDiv = $(
      //         ".previewContent h1,.previewContent h2,.previewContent h3,.previewContent h4,.previewContent h5"
      //       );
      //       if (getMenuDiv.length != 0) {
      //         var hEles = ["h1", "h2", "h3", "h4", "h5"];
      //         $.each(getMenuDiv, function (index, element) {
      //           var nodetext = element.innerHTML.replace(/<\/?[^>]+>/g, "");
      //           nodetext = nodetext.replace(/&nbsp;/gi, "");
      //           var name = element.nodeName.toLowerCase();
      //           if (hEles.includes(name)) {
      //             index++;
      //             var id = `catalogue_${index}`;
      //             element.setAttribute("id", id);
      //             var level = name.replace("h", "");
      //             that.catalogue.push({
      //               id: id,
      //               key: name,
      //               title: nodetext,
      //               level: Number(level),
      //               read: false,
      //             });
      //           }
      //         });
      //       } else {
      //         $("#Content .menuBox").hide();
      //       }
      //       // 添加图注
      //       // 单张图片处理开始
      //       var contentSingleImg = $(".previewContent .pic-single");
      //       contentSingleImg.each(function (index) {
      //         // 创建外层盒子
      //         var setTimeIndex = index;
      //         var picSingleTopBox = $("<span class='pic-single-top'></span>");
      //         var currentSingle = $(contentSingleImg[index]);
      //         if (currentSingle.css("float") == "left") {
      //           currentSingle
      //             .wrap($('<a class="pic-single-box fl"></a>'))
      //             .wrap(picSingleTopBox);
      //         } else if (currentSingle.css("float") == "right") {
      //           currentSingle
      //             .wrap($('<a class="pic-single-box fr"></a>'))
      //             .wrap(picSingleTopBox);
      //         } else {
      //           currentSingle
      //             .wrap($('<a class="pic-single-box"></a>'))
      //             .wrap(picSingleTopBox);
      //         }
      //       // 若有图注则显示图注
      //         var imageNote = currentSingle.attr("imagenote");
      //         if (imageNote && imageNote != "") {
      //           $(
      //             "<div class='pic-imagenote-font'>" + imageNote + "</div>"
      //           ).appendTo(currentSingle.parent().parent());
      //         }
      //         // 若有图题则显示图题
      //         var titleSingle = currentSingle.attr("title");
      //         if (titleSingle && titleSingle != "") {
      //           currentSingle.on("load", function () {
      //             var imgWidth = currentSingle.width();
      //             $(
      //               "<div class='pic-single-font' style='width:" +
      //                 imgWidth +
      //                 "px'>" +
      //                 titleSingle +
      //                 "</div>"
      //             ).appendTo(currentSingle.parent().parent());
      //           });
      //         }
      //         setTimeout(
      //           () => {
      //             $(contentSingleImg[setTimeIndex])
      //               .parent()
      //               .parent(".pic-single-box")
      //               .css({"width": $(contentSingleImg[setTimeIndex]).css("width")});
      //               $(contentSingleImg[setTimeIndex])
      //               .parent()
      //               .parent(".pic-single-box").parent().css({margin:'10px 0'})
      //           },
      //           500,
      //           j
      //         );

      //         // 若有链接则显示跳转
      //         let imageLink = $(contentSingleImg[i]).attr("imagelink");
      //         if (imageLink && imageLink != "") {
      //           $(contentSingleImg[i])
      //             .parent()
      //             .parent(".pic-single-box")
      //             .attr("href", imageLink);
      //           $(contentSingleImg[i])
      //             .parent()
      //             .parent(".pic-single-box")
      //             .addClass("addeffect");
      //         }

      //         $(".previewContent .pic-single-box")
      //           .parent()
      //           .each(function (index, item) {
      //             if ($(item).attr("align")) {
      //               switch ($(item).attr("align")) {
      //                 case "center":
      //                   $(item).css({
      //                     "text-align": "center",
      //                   });
      //                   break;
      //                 case "left":
      //                   $(item).css({
      //                     "text-align": "left",
      //                   });
      //                   break;
      //                 case "right":
      //                   $(item).css({
      //                     "text-align": "right",
      //                   });
      //                   break;

      //                 default:
      //                   break;
      //               }
      //             }
      //           });

      //         if (
      //           $(".previewContent .pic-single-box")
      //             .parent()
      //             .contents()
      //             .filter(function () {
      //               return (
      //                 this.nodeType === 1 && this.nodeName.toLowerCase() !== "a"
      //               ); // 1代表元素节点，且不是<a>标签
      //             }).length > 0
      //         ) {
      //           $(".previewContent .pic-single-box").css({
      //             float: "right",
      //             margin: "10px 0 10px 20px",
      //           });
      //         } else {
      //           currentSingle.parent().parent().parent().css({
      //             "text-indent": 0,
      //             margin: "20px 0",
      //             "text-align": "center",
      //           });
      //         }
      //       });

      //         contentSingleImg.on({}).viewer({
      //             url: 'httpPath',
      //             navbar: false,
      //             title: true
      //         })
      //       //单张图片处理结束
      //         let contentUnionImg = $(".previewContent .pic-union");
      //       for (let i = 0; i < contentUnionImg.length; i++) {
      //         // 创建外层盒子
      //         let picUnionTopBox = $("<span class='pic-union-top' style='text-indent = 0'></span>");
      //         let currentUnion = $(contentUnionImg[i]);
      //         if (currentUnion.css("float") == "left") {
      //           currentUnion
      //             .wrap($('<a class="pic-union-box fl"></a>'))
      //             .wrap(picUnionTopBox);
      //         } else if (currentUnion.css("float") == "right") {
      //           currentUnion
      //             .wrap($('<a class="pic-union-box fr"></a>'))
      //             .wrap(picUnionTopBox);
      //         } else {
      //           currentUnion
      //             .wrap($('<a class="pic-union-box"></a>'))
      //             .wrap(picUnionTopBox);
      //         }
              
      //         setTimeout(() => {
      //           $(contentUnionImg[i])
      //             .parent()
      //             .parent(".pic-union-box")
      //             .css("width", $(contentUnionImg[i]).css("width"));
      //         }, 200);
      //         var galleryDataAll = {
      //           metaids: $(contentUnionImg[i]).attr("metaids").split("##"),
      //           metaposters: $(contentUnionImg[i])
      //             .attr("metaposters")
      //             .split("##"),
      //           metatitles: $(contentUnionImg[i]).attr("metatitles").split("##"),
      //         };
      //         var galleryData = [];
      //         var postAlt = ""
      //         galleryDataAll.metaids.forEach((item, index) => {
      //           if(currentUnion.attr('logopath').indexOf(galleryDataAll.metaposters[index]) == -1){
      //             galleryData.push({
      //               id: item,
      //               poster: galleryDataAll.metaposters[index],
      //               title: galleryDataAll.metatitles[index],
      //             });
      //           }else{
      //             postAlt = galleryDataAll.metatitles[index]
      //           }
      //         });
      //         let titleUnion = $(contentUnionImg[i]).attr("title");
      //         $("<div class='pic-union-font'>" + titleUnion + "</div>").appendTo(
      //           $(contentUnionImg[i]).parent().parent()
      //         );
      //         var galleryHtml =
      //           '<div class="gallery-thumbs"><p class="galleryLogo">图集</p><img src="'+currentUnion.attr('logopath')+'" alt="'+postAlt+'" style="width:100%"><div class="gallery-thumbs-content" style="display:none">';
      //         galleryData.forEach((item) => {
      //           galleryHtml +=
      //             '<img src="' +
      //             item.poster +
      //             '" alt="' +
      //             item.title +
      //             '">';
      //         });
      //         galleryHtml += '</div></div>';
      //         currentUnion.parent().html(galleryHtml);
      //       }
      //         $(".previewContent .pic-union-box").viewer({
      //             url: 'httpPath',
      //             navbar: true,
      //             title: true,
      //             toolbar:true
      //         })
      //       // 处理热链
      //       $("hotlink").each(function (index, item) {
      //         var itemInfo = {};
      //         itemInfo.title = item.innerHTML;
      //         var id,name="",code="",link="",url = "";
      //         id = $(item).attr('id');
      //         if(id){
      //           // 有id使用id
      //           url = "/preview?id="+id;
      //         }else{
      //           //id不存在使用name和code
      //           name = $(item).attr('name');
      //           code = $(item).attr('code') ? $(item).attr("code") : $(item).attr ('innerCode') ? $(item).attr("innerCode") : $(item).attr ('innercode');
      //           if(name && code){
      //             url = "/preview?name=" + name + "&code=" + code + "&sourceId=" + data.id;
      //           }else{
      //             link = $(item).attr('url');
      //           }
      //         }

      //         if(!id && !name && !code && !link){
      //           //如果hotlink标签这4个属性都不存在则移除hotlink保留文本
      //           $(item).replace (item.html ())
      //         }
      //         let aurl = url + link;

      //         $(item).replaceWith(
      //           $('<a class="hotlink" target="_blank" href="' + aurl + '">' + itemInfo.title + "</a>")[0]
      //         );

      //         // if ($(item).attr("name")) {
      //         //   if ($(item).attr("innerCode")||$(item).attr("innerCode")) {
      //         //     item.replaceWith(
      //         //       $(
      //         //         '<a class="hotlink" target="_blank" href= /preview?name=' +
      //         //           $(item).attr("name") +
      //         //           "&code=" +
      //         //           $(item).attr("innerCode") +
      //         //           ">" +
      //         //           itemInfo.title +
      //         //           "</a >"
      //         //       )[0]
      //         //     );
      //         //   } else if ($(item).attr("code")) {
      //         //     item.replaceWith(
      //         //       $(
      //         //         '<a class="hotlink" target="_blank" href= /preview?name=' +
      //         //           $(item).attr("name") +
      //         //           "&code=" +
      //         //           $(item).attr("code") +
      //         //           ">" +
      //         //           itemInfo.title +
      //         //           "</a >"
      //         //       )[0]
      //         //     );
      //         //   }
      //         // } else if ($(item).attr("id")) {
      //         //   itemInfo.id = $(item).attr("id");
      //         //   item.replaceWith(
      //         //     $(
      //         //       '<a class="hotlink" target="_blank" href= /preview?id=' +
      //         //         itemInfo.id +
      //         //         ">" +
      //         //         itemInfo.title +
      //         //         "</a >"
      //         //     )[0]
      //         //   );
      //         // } else if ($(item).attr("url")) {
      //         //   var currentUrl = $(item).attr("url");
      //         //   itemInfo.id = that.getQueryParamValue(currentUrl, "wordId");
      //         //   item.replaceWith(
      //         //     $(
      //         //       '<a class="hotlink" target="_blank" href= /preview?id=' +
      //         //         itemInfo.id +
      //         //         ">" +
      //         //         itemInfo.title +
      //         //         "</a >"
      //         //     )[0]
      //         //   );
      //         // }
      //       });
      //       // $(".previewContent img").each(function () {
      //       //   if ($(this).attr("data-type")) {
      //       //     $("img.reference").each(function (index, item) {
      //       //       let sup = $(item).attr("data-text");
      //       //       let supItem = $(
      //       //         '<sup style="color:#596fab" attr="' +
      //       //           sup +
      //       //           '">[' +
      //       //           (index + 1) +
      //       //           "]</sup>"
      //       //       )[0];
      //       //       $(supItem).addClass("websup");
      //       //       $(supItem).webuiPopover({
      //       //         placement: "bottom",
      //       //         trigger: "hover",
      //       //         title: "注释内容",
      //       //         content: sup,
      //       //       });
      //       //       item.replaceWith(supItem);
      //       //     });
      //       //   } else {
      //       //     $(".previewContent img").parent().addClass("imgBox");
      //       //     setTimeout(function () {
      //       //       $.each($(".previewContent img"), function () {
      //       //         $(this)
      //       //           .parent()
      //       //           .append(
      //       //             "<span style='width:" +
      //       //               $(this).width() +
      //       //               "px'>" +
      //       //               $(this).attr("title") +
      //       //               "</span>"
      //       //           );
      //       //       });
      //       //     }, 50);
      //       //   }
      //       // });
      //       // $(".previewContent img").parent().addClass("imgBox");
      //       // setTimeout(function () {
      //       //   $.each($(".previewContent img"), function () {
      //       //     $(this)
      //       //       .parent()
      //       //       .append(
      //       //         "<span style='width:" +
      //       //           $(this).width() +
      //       //           "px'>" +
      //       //           $(this).attr("title") +
      //       //           "</span>"
      //       //       );
      //       //   });
      //       // }, 500);
      //     } else {
      //       that.$message({
      //         message: response.msg,
      //         duration: 0,
      //         showClose: true,
      //         type: "error",
      //         offset: 100,
      //       });
      //     }
      //   },
      //   error: function (data) {
      //     console.log(data);
      //   },
      // });
    },50)
   
  },
  methods: {
    getContentData(currentId,versionFlag){
      var that = this;
      var param = {
        id: currentId,
      }
      if (versionFlag) {
        param.version = this.$route.query.version
      }
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/word/preview",
        data: param,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            var data = response.obj;
            
            document.title = data.name + "-大百科";
            if(data.adverTags){
              that.adverTagsData = data.adverTags;
            }

            if(data.wordTags.length>0){
              data.wordTags.forEach((item)=>{
                switch (item.type) {
                  case 10:
                    that.itemTagsData.push(item)
                    break;
                  case 20:
                    that.contentTagsData.push(item)
                    break;
                  default:
                    break;
                }
              })
              console.log(that.itemTagsData);
              
            }

            if (data.headText != "[]") {
              that.headTextList = JSON.parse(data.headText);
            }
            if (data.authorText != "[]" && data.authorText != "[{}]") {
              // that.authorText = JSON.parse(data.authorText)[0].authorName;
              var athorHtml = "";
                JSON.parse(data.authorText).forEach(function (item) {
                  if (item.isAway == "Y") {
                    athorHtml +=
                      "、<span style='font-weight:normal;border: 1px solid #ccc'>" +
                      item.authorName +
                      "</span>";
                  } else {
                    athorHtml +=
                      "、<span style='font-weight:normal'>" +
                      item.authorName +
                      "</span>";
                  }
                });
                athorHtml = athorHtml.slice(1);
                $(".author").html(athorHtml);
            }
            // 处理大事年表
            if (data.chronologyText != "{}" && data.chronologyText != null && data.chronologyText != "[]") {
              that.chronologyList = JSON.parse(data.chronologyText).list;
            } else {
              $(".chronologyContent").hide();
            }
            if (data.summaryFields != "[]" && data.summaryFields != null) {
              that.summaryFieldsList = JSON.parse(data.summaryFields);
            }

            if (data.descText != "") {
              that.descText = data.descText;
              $(".descTextContent").html(data.descText);
            }

            that.articleTitle = data.name;
            that.sourceInfo = data.sourceInfo.name;
            that.subjectInfo = data.subjectInfo.subBranch;
            that.securityLevel = data.securityLevel;
            // that.refText = data.refText;

            // 处理著作
            if (data.opusText != "[]") {
              var opusData = JSON.parse(data.opusText);
              that.opusData = JSON.parse(data.opusText);
              var opusHtml = "";
              for (var i = 0; i < opusData.length; i++) {
                opusHtml += "<li>";
                if (opusData[i].mainPerson != undefined) {
                  opusHtml += opusData[i].mainPerson + " . ";
                }
                if (opusData[i].bookName != undefined) {
                  opusHtml += opusData[i].bookName + " . ";
                }
                if (opusData[i].publishAddress != undefined) {
                  opusHtml += opusData[i].publishAddress + " : ";
                }
                if (opusData[i].publishauthor != undefined) {
                  opusHtml += opusData[i].publishauthor + " . ";
                }
                if (opusData[i].publishYear != undefined) {
                  opusHtml += opusData[i].publishYear + " . ";
                }
                opusHtml += "</li>";
              }
              $(".opusContent .opusList").html(opusHtml);
            } else {
              $(".opusContent").hide();
            }

            // 处理引文
            if (data.refText != "[]") {
              var refData = JSON.parse(data.refText);
              var refHtml = "";
              for (var j = 0; j < refData.length; j++) {
                if (refData[j].type == "1") {
                  var ref1Data = refData[j].list;
                  for (var k = 0; k < ref1Data.length; k++) {
                    refHtml += "<li>";
                    if (ref1Data[k].mainPerson != undefined) {
                      refHtml += ref1Data[k].mainPerson + " . ";
                    }
                    if (ref1Data[k].bookName != undefined) {
                      refHtml += ref1Data[k].bookName + " . ";
                    }
                    if (ref1Data[k].publishAddress != undefined) {
                      refHtml += ref1Data[k].publishAddress + " : ";
                    }
                    if (ref1Data[k].publishauthor != undefined) {
                      refHtml += ref1Data[k].publishauthor + " . ";
                    }
                    if (ref1Data[k].publishYear != undefined) {
                      refHtml += ref1Data[k].publishYear + " . ";
                    }
                    refHtml += "</li>";
                  }
                } else if (refData[j].type == "2") {
                  var ref2Data = refData[j].list;
                  for (var l = 0; l < ref2Data.length; l++) {
                    refHtml += "<li>";
                    if (ref2Data[l].linkAddress != undefined) {
                      refHtml +=
                        "<a href='" +
                        ref2Data[l].linkAddress +
                        " target='_blank'>";
                    }
                    if (ref2Data[l].mainPerson != undefined) {
                      refHtml += ref2Data[l].mainPerson + " . ";
                    }
                    if (ref2Data[l].bookName != undefined) {
                      refHtml += ref2Data[l].bookName + " . ";
                    }
                    if (ref2Data[l].linkAddress != undefined) {
                      refHtml += "</a>";
                    }
                    if (ref2Data[l].bookNameL != undefined) {
                      refHtml += ref2Data[l].bookNameL + " , ";
                    }
                    if (ref2Data[l].publishYear != undefined) {
                      refHtml += ref2Data[l].publishYear + " . ";
                    }
                    if (ref2Data[l].Volume != undefined) {
                      refHtml += ref2Data[l].Volume + " . ";
                    }
                    if (ref2Data[l].pageNumber != undefined) {
                      refHtml += ref2Data[l].pageNumber + " . ";
                    }
                    refHtml += "</li>";
                  }
                }
              }

              $(".refContent .refList").html(refHtml);
            } else {
              $(".refContent").hide();
            }

            // 处理otherText内容
            if (data.otherText != "[]" && data.otherText != null) {
              var otherData = JSON.parse(data.otherText),
                otherHtml = "";
              otherData.forEach((item) => {
                otherHtml += "<li>" + item + "</li>";
              });
              $(".otherExtendContent .otherExtendList").html(otherHtml);
            } else {
              $(".otherExtendContent").hide();
            }

            // 处理义项信息
            
            if (data.anotherWords.length > 1) {
              var anotherWordsData = data.anotherWords,
              anotherWordsHtml = "";
              var listShow = ''
              anotherWordsData.forEach((item) => {
                if(item.anoterName && item.anoterName!=""){
                  listShow = item.anoterName
                }else{
                  listShow = item.subBranch
                }
                if(item.id == data.id){
                  anotherWordsHtml += "<li>" + listShow + "</li>";  
                }else{
                  anotherWordsHtml += "<li><a href='/preview?id="+ item.id +"' target='_blank'>" + listShow + "</a></li>";  
                }
              });
              $(".anotherWords .anotherWordsList").html(anotherWordsHtml);
              
            } else {
              $(".anotherWords").hide();
            }

            // 处理扩展阅读
            if (data.extendText != "[]") {
              var extendData = JSON.parse(data.extendText);
              var extendHtml = "";
              for (var m = 0; m < extendData.length; m++) {
                if (extendData[m].type == "1") {
                  var extend1Data = extendData[m].list;
                  for (var p = 0; p < extend1Data.length; p++) {
                    extendHtml += "<li>";
                    if (extend1Data[p].linkAddress != undefined) {
                      extendHtml +=
                        "<a href='" +
                        extend1Data[p].linkAddress +
                        " target='_blank'>";
                    }
                    if (extend1Data[p].leaders != undefined) {
                      extendHtml += extend1Data[p].leaders + " . ";
                    }
                    if (extend1Data[p].speechName != undefined) {
                      extendHtml += extend1Data[p].speechName + " . ";
                    }
                    if (extend1Data[p].linkAddress != undefined) {
                      extendHtml += "</a>";
                    }
                    extendHtml += "</li>";
                  }
                } else if (extendData[m].type == "2") {
                  var extend2Data = extendData[m].list;
                  for (var q = 0; q < extend2Data.length; q++) {
                    extendHtml += "<li>";
                    if (extend2Data[q].mainPerson != undefined) {
                      extendHtml += extend2Data[q].mainPerson + " . ";
                    }
                    if (extend2Data[q].bookName != undefined) {
                      extendHtml += extend2Data[q].bookName + " . ";
                    }
                    if (extend2Data[q].publishAddress != undefined) {
                      extendHtml += extend2Data[q].publishAddress + " : ";
                    }
                    if (extend2Data[q].publishauthor != undefined) {
                      extendHtml += extend2Data[q].publishauthor + " . ";
                    }
                    if (extend2Data[q].publishYear != undefined) {
                      extendHtml += extend2Data[q].publishYear + " . ";
                    }
                    extendHtml += "</li>";
                  }
                } else if (extendData[m].type == "3") {
                  var extend3Data = extendData[m].list;
                  for (var r = 0; r < extend3Data.length; r++) {
                    refHtml += "<li>";
                    if (extend3Data[r].linkAddress != undefined) {
                      extendHtml +=
                        "<a href='" +
                        extend3Data[r].linkAddress +
                        " target='_blank'>";
                    }
                    if (extend3Data[r].mainPerson != undefined) {
                      extendHtml += extend3Data[r].mainPerson + " . ";
                    }
                    if (extend3Data[r].bookName != undefined) {
                      extendHtml += extend3Data[r].bookName + " . ";
                    }
                    if (extend3Data[r].linkAddress != undefined) {
                      extendHtml += "</a>";
                    }
                    if (extend3Data[r].bookNameL != undefined) {
                      extendHtml += extend3Data[r].bookNameL + " , ";
                    }
                    if (extend3Data[r].publishYear != undefined) {
                      extendHtml += extend3Data[r].publishYear + " . ";
                    }
                    if (extend3Data[r].Volume != undefined) {
                      extendHtml += extend3Data[r].Volume + " . ";
                    }
                    if (extend3Data[r].pageNumber != undefined) {
                      extendHtml += extend3Data[r].pageNumber + " . ";
                    }
                    extendHtml += "</li>";
                  }
                } else if (extendData[m].type == "4") {
                  var extend4Data = extendData[m].list;
                  for (var n = 0; n < extend4Data.length; n++) {
                    extendHtml += "<li>";
                    if (extend4Data[n].linkAddress != undefined) {
                      extendHtml +=
                        "<a href='" +
                        extend4Data[n].linkAddress +
                        " target='_blank'>";
                    }
                    if (extend4Data[n].bookName != undefined) {
                      extendHtml += extend4Data[n].bookName + " . ";
                    }
                    if (extend4Data[n].websiteName != undefined) {
                      extendHtml += extend4Data[n].websiteName + " . ";
                    }
                    if (extend4Data[n].linkAddress != undefined) {
                      extendHtml += "</a>";
                    }
                    extendHtml += "</li>";
                  }
                } else if (extendData[m].type == "5") {
                  var extend5Data = extendData[m].list;
                  for (var t = 0; t < extend5Data.length; t++) {
                    extendHtml += "<li>";
                    if (extend5Data[t].linkAddress != undefined) {
                      extendHtml +=
                        "<a href='" +
                        extend5Data[t].linkAddress +
                        " target='_blank'>";
                    }
                    if (extend5Data[t].name != undefined) {
                      extendHtml += extend5Data[t].name;
                    }
                    if (extend5Data[t].linkAddress != undefined) {
                      extendHtml += "</a>";
                    }
                    extendHtml += "</li>";
                  }
                }
              }
              $(".extendContent .extendList").html(extendHtml);
            } else {
              $(".extendContent").hide();
            }

            // 生成正文内容
            $(".previewContent").html(data.content);
            
            $(".previewContent p").each(function() {
              $(this).html($(this).html().trimStart())
            });

            $("note").each(function () {
              var sup = $(this).attr("title");
              if (sup && sup.length > 0) {
                $(this).addClass("websup");
                $(this).webuiPopover({
                  placement: "bottom",
                  trigger: "hover",
                  title: "注释内容",
                  content: sup,
                  width: 200,
                });
              }
            });

            //生成目录

            var getMenuDiv = $(
              ".previewContent h1,.previewContent h2,.previewContent h3,.previewContent h4,.previewContent h5"
            );
            if (getMenuDiv.length != 0) {
              var hEles = ["h1", "h2", "h3", "h4", "h5"];
              $.each(getMenuDiv, function (index, element) {
                var nodetext = element.innerHTML.replace(/<\/?[^>]+>/g, "");
                nodetext = nodetext.replace(/&nbsp;/gi, "");
                var name = element.nodeName.toLowerCase();
                if (hEles.includes(name)) {
                  index++;
                  var id = `catalogue_${index}`;
                  element.setAttribute("id", id);
                  var level = name.replace("h", "");
                  that.catalogue.push({
                    id: id,
                    key: name,
                    title: nodetext,
                    level: Number(level),
                    read: false,
                  });
                }
              });
            } else {
              $("#Content .menuBox").hide();
            }
            // 添加图注
            // 单张图片处理开始
            var contentSingleImg = $(".previewContent .pic-single");
            contentSingleImg.each(function (index) {
              // 创建外层盒子
              var setTimeIndex = index;
              var picSingleTopBox = $("<span class='pic-single-top'></span>");
              var currentSingle = $(contentSingleImg[index]);
              if (currentSingle.css("float") == "left") {
                currentSingle
                  .wrap($('<a class="pic-single-box fl"></a>'))
                  .wrap(picSingleTopBox);
              } else if (currentSingle.css("float") == "right") {
                currentSingle
                  .wrap($('<a class="pic-single-box fr"></a>'))
                  .wrap(picSingleTopBox);
              } else {
                currentSingle
                  .wrap($('<a class="pic-single-box"></a>'))
                  .wrap(picSingleTopBox);
              }
            // 若有图注则显示图注
              var imageNote = currentSingle.attr("imagenote");
              if (imageNote && imageNote != "") {
                $(
                  "<div class='pic-imagenote-font'>" + imageNote + "</div>"
                ).appendTo(currentSingle.parent().parent());
              }
              // 若有图题则显示图题
              var titleSingle = currentSingle.attr("title");
              if (titleSingle && titleSingle != "") {
                currentSingle.on("load", function () {
                  var imgWidth = currentSingle.width();
                  $(
                    "<div class='pic-single-font' style='width:" +
                      imgWidth +
                      "px'>" +
                      titleSingle +
                      "</div>"
                  ).appendTo(currentSingle.parent().parent());
                });
              }
              setTimeout(
                () => {
                  $(contentSingleImg[setTimeIndex])
                    .parent()
                    .parent(".pic-single-box")
                    .css({"width": $(contentSingleImg[setTimeIndex]).css("width")});
                    $(contentSingleImg[setTimeIndex])
                    .parent()
                    .parent(".pic-single-box").parent().css({margin:'10px 0'})
                },
                500,
                j
              );

              // 若有链接则显示跳转
              let imageLink = $(contentSingleImg[i]).attr("imagelink");
              if (imageLink && imageLink != "") {
                $(contentSingleImg[i])
                  .parent()
                  .parent(".pic-single-box")
                  .attr("href", imageLink);
                $(contentSingleImg[i])
                  .parent()
                  .parent(".pic-single-box")
                  .addClass("addeffect");
              }

              $(".previewContent .pic-single-box")
                .parent()
                .each(function (index, item) {
                  if ($(item).attr("align")) {
                    switch ($(item).attr("align")) {
                      case "center":
                        $(item).css({
                          "text-align": "center",
                        });
                        break;
                      case "left":
                        $(item).css({
                          "text-align": "left",
                        });
                        break;
                      case "right":
                        $(item).css({
                          "text-align": "right",
                        });
                        break;

                      default:
                        break;
                    }
                  }
                });

              if (
                $(".previewContent .pic-single-box")
                  .parent()
                  .contents()
                  .filter(function () {
                    return (
                      this.nodeType === 1 && this.nodeName.toLowerCase() !== "a"
                    ); // 1代表元素节点，且不是<a>标签
                  }).length > 0
              ) {
                $(".previewContent .pic-single-box").css({
                  float: "right",
                  margin: "10px 0 10px 20px",
                });
              } else {
                currentSingle.parent().parent().parent().css({
                  "text-indent": 0,
                  margin: "20px 0",
                  "text-align": "center",
                });
              }
            });

              contentSingleImg.on({}).viewer({
                  url: 'httpPath',
                  navbar: false,
                  title: true
              })
            //单张图片处理结束
              let contentUnionImg = $(".previewContent .pic-union");
            for (let i = 0; i < contentUnionImg.length; i++) {
              // 创建外层盒子
              let picUnionTopBox = $("<span class='pic-union-top' style='text-indent = 0'></span>");
              let currentUnion = $(contentUnionImg[i]);
              if (currentUnion.css("float") == "left") {
                currentUnion
                  .wrap($('<a class="pic-union-box fl"></a>'))
                  .wrap(picUnionTopBox);
              } else if (currentUnion.css("float") == "right") {
                currentUnion
                  .wrap($('<a class="pic-union-box fr"></a>'))
                  .wrap(picUnionTopBox);
              } else {
                currentUnion
                  .wrap($('<a class="pic-union-box"></a>'))
                  .wrap(picUnionTopBox);
              }
              
              setTimeout(() => {
                $(contentUnionImg[i])
                  .parent()
                  .parent(".pic-union-box")
                  .css("width", $(contentUnionImg[i]).css("width"));
              }, 200);
              var galleryDataAll = {
                metaids: $(contentUnionImg[i]).attr("metaids").split("##"),
                metaposters: $(contentUnionImg[i])
                  .attr("metaposters")
                  .split("##"),
                metatitles: $(contentUnionImg[i]).attr("metatitles").split("##"),
              };
              var galleryData = [];
              var postAlt = ""
              galleryDataAll.metaids.forEach((item, index) => {
                if(currentUnion.attr('logopath').indexOf(galleryDataAll.metaposters[index]) == -1){
                  galleryData.push({
                    id: item,
                    poster: galleryDataAll.metaposters[index],
                    title: galleryDataAll.metatitles[index],
                  });
                }else{
                  postAlt = galleryDataAll.metatitles[index]
                }
              });
              let titleUnion = $(contentUnionImg[i]).attr("title");
              $("<div class='pic-union-font'>" + titleUnion + "</div>").appendTo(
                $(contentUnionImg[i]).parent().parent()
              );
              var galleryHtml =
                '<div class="gallery-thumbs"><p class="galleryLogo">图集</p><img src="'+currentUnion.attr('logopath')+'" alt="'+postAlt+'" style="width:100%"><div class="gallery-thumbs-content" style="display:none">';
              galleryData.forEach((item) => {
                galleryHtml +=
                  '<img src="' +
                  item.poster +
                  '" alt="' +
                  item.title +
                  '">';
              });
              galleryHtml += '</div></div>';
              currentUnion.parent().html(galleryHtml);
            }
              $(".previewContent .pic-union-box").viewer({
                  url: 'httpPath',
                  navbar: true,
                  title: true,
                  toolbar:true
              })
            // 处理热链
            $("hotlink").each(function (index, item) {
              var itemInfo = {};
              itemInfo.title = item.innerHTML;
              var id,name="",link="",url = "";
              id = $(item).attr('id');
              if(id){
                // 有id使用id
                url = "/preview?id="+id;
              }else{
                //id不存在使用name和code
                name = $(item).attr('name');
                // code = $(item).attr('code') ? $(item).attr("code") : $(item).attr ('innerCode') ? $(item).attr("innerCode") : $(item).attr ('innercode');
                if(name){
                  url = "/preview?name=" + name + "&sourceId=" + data.id;
                }else{
                  link = $(item).attr('url');
                }
              }

              if(!id && !name && !link){
                //如果hotlink标签这4个属性都不存在则移除hotlink保留文本
                $(item).replace (item.html ())
              }
              let aurl = url + link;

              $(item).replaceWith(
                $('<a class="hotlink" target="_blank" href="' + aurl + '">' + itemInfo.title + "</a>")[0]
              );
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    menuClick(current) {
      current.read = true;
      var anchorElement = $("#" + current.id);
      if (anchorElement.length > 0) {
        $("html, body").animate(
          {
            scrollTop: anchorElement.offset().top - 120,
          },
          500
        );
      }
      $(".catalogue-box #menu" + current.id).addClass("catalogueActive");
      $(".catalogue-box #menu" + current.id)
        .siblings()
        .removeClass("catalogueActive");
    },
    updateScrollDistance() {
      this.scrollDistance =
        window.pageYOffset || document.documentElement.scrollTop;
      var scrollTop = this.scrollDistance;
      for (let i = 0; i < this.catalogue.length; i++) {
        //获取小标题距离屏幕顶端的距离
        var offsetTop = document.querySelector(
          "#" + this.catalogue[i].id
        ).offsetTop;
        //根据条件做出判断，我这里是当小标题和屏幕顶端的距离小于300且没有被标明在读时，就将其背景颜色改变。
        if (offsetTop - scrollTop < 300 && offsetTop - scrollTop > 0) {
          $(".catalogue-box #menu" + this.catalogue[i].id).addClass(
            "catalogueActive"
          );
          $(".catalogue-box #menu" + this.catalogue[i].id)
            .siblings()
            .removeClass("catalogueActive");
        }
      }
    },
    printPage() {
      window.print();
    },
    closeSide() {
      if ($(".menuBox").css("left").indexOf("-") !== -1) {
        $(".menuBox").animate(
          {
            left: "0%", // 向右移动100px
          },
          "slow"
        );
        $("#Content .menuBox .menuButton i").removeClass("el-icon-notebook-2");
        $("#Content .menuBox .menuButton i").addClass("el-icon-close");
      } else {
        $(".menuBox").animate(
          {
            left: "-16.5%", // 向右移动100px
          },
          "slow"
        );
        $("#Content .menuBox .menuButton i").addClass("el-icon-notebook-2");
        $("#Content .menuBox .menuButton i").removeClass("el-icon-close");
      }
    },
  },
};
</script>

<style>
#Content {
  font-family: "DBK";
  position: relative;
}

#Content .publishPreviewNav {
  box-shadow: 0px 0px 24px 0px #0000001c;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 999;
  padding: 10px 30px;
  border-left: 5px solid #45be89;
}

#Content .publishPreviewNav .publishNavTitle {
  font-size: 24px;
  font-weight: bolder;
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  margin-left: 10px;
}

#Content .menuBox {
  position: fixed;
  width: 15%;
  padding: 20px 10px 20px 10px;
  height: calc(100% - 71px);
  top: 70px;
  left: 0;
  box-shadow: 1px 3px 8px 0px rgba(102, 102, 102, 0.5);
  border-left: 5px solid #45be89;
  color: #888;
}

#Content .menuBox .nav-title {
  font-size: 18px;
  margin-bottom: 30px;
}
#Content .menuBox .catalogue-box {
  padding-left: 10px;
}

#Content note:after{
  color: #45be89;
  font-weight: bold;
}

#Content .contentBox .pic-single-font {
  margin: 0 auto;
  margin-top: -10px;
  background-color: #fff;
  border-bottom: 1px solid #45be89;
  box-shadow: 0px 0px 3px 0px rgba(102, 102, 102, 0.5);
}

#Content .menuBox .catalogue-box li {
  padding: 5px 0;
  margin: 15px 0;
  cursor: pointer;
}
#Content .menuBox .catalogue-box li::marker {
  color: #45be89;
}

#Content .menuBox .catalogue-box li:hover a {
  color: #45be89;
  font-weight: bolder;
  /* background-color: rgba(80, 181, 141, 0.1); */
}

#Content .menuBox .catalogue-box li.catalogueActive a {
  color: #45be89;
  font-weight: bolder;
  /* background-color: rgba(80, 181, 141, 0.1); */
}

#Content .menuBox .catalogue-box li a {
  color: #888;
}

#Content .menuBox .catalogue-box .catalogue1 {
  font-size: 18px;
}

#Content .menuBox .catalogue-box .catalogue2 {
  font-size: 17px;
  list-style-type: disc;
  list-style-position: inside;
  padding-left: 10px;
}

#Content .menuBox .catalogue-box .catalogue2 a {
  margin-left: -15px;
}

#Content .menuBox .catalogue-box .catalogue3 {
  font-size: 16px;
  list-style-type: circle;
  list-style-position: inside;
  padding-left: 20px;
}
#Content .menuBox .catalogue-box .catalogue3 a {
  margin-left: -12px;
}

#Content .menuBox .catalogue-box .catalogue4 {
  font-size: 15px;
  list-style-type: square;
  list-style-position: inside;
  padding-left: 30px;
}

#Content .menuBox .catalogue-box .catalogue4 a {
  margin-left: -9px;
}

#Content .menuBox .catalogue-box .catalogue5 {
  font-size: 14px;
  list-style-type: disc;
  list-style-position: inside;
  padding-left: 40px;
}

#Content .menuBox .catalogue-box .catalogue5 a {
  margin-left: -6px;
}

#Content .menuBox .menuButton {
  position: absolute;
  top: 0px;
  right: -40px;
  width: 40px;
  height: 40px;
  padding: 0;
  background: #45be89;
  color: #fff;
  cursor: pointer;
  font-size: 30px;
  border-radius: 0;
}

#Content .contentBox {
  padding: 70px 20% 0;
}

#Content .contentBox .articleTitle {
  margin-top: 20px;
}

#Content .contentBox .articleTitle p {
  font-size: 40px;
  padding: 20px 0;
  color: #000;
  font-weight: bolder;
}


#Content .chronologyContent li{
  margin: 30px 0;
}

#Content .chronologyContent .chronologyItemTitle{
  font-size: 26px;
  font-weight: bolder;
  color:#888888;
  margin-bottom: 15px;
}

#Content .chronologyContent .chronologyItemContent p{
  line-height: 1.7em;
  margin: 15px 0;
}

#Content .contentBox .previewContent p {
  line-height: 2em;
  font-size: 16px;
  text-indent: 2em;
}

#Content .contentBox .previewContent h1 {
  margin: 40px 0;
}

#Content .contentBox .previewContent h2 {
  margin: 30px 0;
}

#Content .contentBox .previewContent h3 {
  margin: 20px 0;
}

#Content .contentBox .previewContent h4 {
  margin: 10px 0;
}

#Content .contentBox .previewContent {
  padding: 0;
}


#Content .gallery-thumbs{
  position: relative;
  width: 400px;
  margin: 0 auto;
  text-indent: 0;
}

#Content .gallery-thumbs .galleryLogo{
  position: absolute;
  top: 1%;
  left: 1%;
  width: 75px;
  height: 25px;
  border-radius: 5px;
  z-index: 10;
  font-size: 14px !important;
  text-align: center !important;
  background: rgb(41, 90, 70);
  color: #fff;
  text-indent: 0!important;
  line-height: 25px !important;
}

#Content .pic-union-font{
  width: 400px;
  margin: 0 auto;
  text-align: center;
  text-indent: 0;
  padding: 10px 0;
  margin-top: -10px;
  background-color: #fff;
  border-bottom: 1px solid #45be89;
  box-shadow: 0px 0px 3px 0px rgba(102, 102, 102, 0.5);
}

#Content .contentBox .moduleTitle {
  font-size: 22px;
  font-weight: bolder;
  border-bottom: 1px solid rgba(35, 77, 60, 0.4);
  color: #295a46;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
  font-family: "微软雅黑";
}

#Content .contentBox .mainContent {
  margin-top: 20px;
  margin-bottom: 50px;
}

#Content .contentBox .mainContent .imgBox span,
#Content .contentBox .mainContent .imgBox img {
  display: block;
  margin: 0 auto;
}

#Content .contentBox .mainContent .imgBox span {
  padding: 5px 0;
  border-bottom: 2px solid #50b58d;
  box-shadow: 0px 0px 2px 0 #cdcdcd;
}

#Content .contentBox .basicInfo .basicContent {
  overflow: auto;
}

#Content .contentBox .basicInfo .basicContent::after {
  content: "";
  display: inline-block;
  clear: both;
}

#Content .contentBox .basicInfo .basicContent div {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

#Content .contentBox .basicInfo .basicContent p span {
  font-weight: bolder;
  font-family: "微软雅黑";
}

.infoText {
  overflow: auto;
}

.infoText::after {
  content: "";
  display: inline-block;
  clear: both;
}

.infoText p {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

.infoText p span {
  font-weight: bolder;
}

.opusContent .opusList,
.refContent .refList,
.extendContent .extendList,
.otherExtendContent .otherExtendList {
  padding-left: 20px;
  margin-bottom: 50px;
}

.opusContent .opusList li,
.refContent .refList li,
.extendContent .extendList li,
.otherExtendContent .otherExtendList li {
  list-style-type: disc;
  margin: 10px 0;
}

.refContent .refList li a,
.extendContent .extendList li a,
.otherExtendContent .otherExtendList li a {
  color: #50b58d;
}

.previewPageTitle {
  margin-top: 20px;
  height: 45px;
}

.previewPageTitle img {
  float: left;
  display: block;
  margin-right: 10px;
}

.previewPageTitle span {
  display: block;
  line-height: 45px;
}

#Content .anotherWordsList{
  list-style-type: disc;
  padding-left: 20px;
}
#Content .anotherWordsList li{
  margin: 10px 0;
}

#Content .anotherWordsList li a{
  color: #295a46;
}

#Content .pic-single-box .pic-single-top img{
  max-width: 600px;
}
</style>
